import { render } from "./POSView.vue?vue&type=template&id=7f8d3094&scoped=true"
import script from "./POSView.vue?vue&type=script&lang=js"
export * from "./POSView.vue?vue&type=script&lang=js"

import "./POSView.vue?vue&type=style&index=0&id=7f8d3094&lang=scss&scoped=true"
import "./POSView.vue?vue&type=style&index=1&id=7f8d3094&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8d3094"]])

export default __exports__